import type { DownloadUrlResponse, PublicShareInfoResponse } from '@tabita/contracts';
import { apiRequest } from './api-client';

/** `/s/:token` — opening a Mi Nube share link with no session. See
 *  `cloudApi.unlockShareAsViewer` for the signed-in-recipient counterpart. */
export const publicCloudShareApi = {
  getInfo(token: string, signal?: AbortSignal) {
    return apiRequest<PublicShareInfoResponse>(`/files/shares/${token}`, {
      anonymous: true,
      signal,
    });
  },
  unlock(token: string, password?: string) {
    return apiRequest<DownloadUrlResponse>(`/files/shares/${token}/unlock`, {
      method: 'POST',
      body: { password: password ?? null },
      anonymous: true,
    });
  },
};
